import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Option } from 'models/OptionModel';


const OptionList: React.FC = () => {
  const width = { name: 30, group: 20, action: 20, comment: 30 };
  const [formId, formName] = [Code.Form.Id.OPTION, Code.Form.Name.OPTION];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, rows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [optionData, setOptionData] = useState<Option[]>([]); 
  const [selectedOption, setselectedOption] = useState<Option | null>(null);
  
  const [groupId, setGroupId] = useState<number>(1);
  const [groupOptions, setGroupOptions] = Hooks.Form.Options();

  const triggers = [pno, rows, search, activeId, groupId];
  const Privilege = Hooks.Privilege.List(formId);

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.Form.Name.GROUP, Code.Option.Common.ALL, setGroupOptions, setError, true);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, rows, Name.Option.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Option.Id, 
        Name.Option.Name, 
        Name.Option.Comment, 
        Name.Common.GroupName,
        Name.Common.ActionName
      ]),
      group_id: groupId,
    });
     
    await API.Data.List<Option>(url, setOptionData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Group} options={groupOptions} onChange={(value) => { setGroupId(value);  callListData();  }} />
              <Control.Dropdown title={Title.State} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, optionData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Title, width.name],
                [Title.Group, width.group],
                [Title.Action, width.action],
                [Title.Comment, width.comment], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(optionData) && (
              <Control.Grid.Row>
                {optionData.map((optionData) => { return (
                <Control.Grid.Data<Option> key={optionData.option_id} itemKey={optionData.option_key} data={optionData} setMenuPosition={setMenuPosition} setSelectedData={setselectedOption} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={optionData.option_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, optionData.option_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [optionData.option_name, width.name], 
                    [optionData.group_name, width.group],
                    [optionData.action_name, width.action],
                    [optionData.option_comment, width.comment],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={optionData.option_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={rows} loading={loading} error={error} dataLength={optionData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName, selectedOption?.option_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedOption?.option_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default OptionList;